<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('feedback.create')
  }),
  computed: {
    ...mapState('feedback', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('feedback.title'), to: { name: 'feedback.index' } },
      { text: vm.$t('feedback.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('feedback/clearItem')
      await store.dispatch('feedback/fetchEnums')
      await store.dispatch('feedback/fetchSiteVersions')
      await store.dispatch('feedback/fetchFeedbackSubjects')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('feedback', ['createItem', 'updateItem'])
  }
}
</script>
